import React from 'react';

function EyeShowIcon(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M10,2.2C7.2,2.2,4.9,3.5,3.3,5C1.7,6.5,0.6,8.3,0.1,9.6C0,9.8,0,10.2,0.1,10.4c0.5,1.2,1.6,3,3.2,4.6c1.6,1.5,3.9,2.8,6.7,2.8s5.1-1.3,6.7-2.8c1.6-1.5,2.7-3.3,3.2-4.6c0.1-0.3,0.1-0.6,0-0.9c-0.5-1.2-1.6-3-3.2-4.6C15,3.5,12.8,2.2,10,2.2z M5,10c0-2.8,2.2-5,5-5s5,2.2,5,5s-2.2,5-5,5S5,12.8,5,10z M10,7.8C10,9,9,10,7.8,10c-0.2,0-0.5,0-0.7-0.1c-0.2-0.1-0.4,0.1-0.4,0.3c0,0.2,0,0.5,0.1,0.7c0.5,1.8,2.3,2.8,4.1,2.4s2.8-2.3,2.4-4.1c-0.4-1.4-1.7-2.4-3.1-2.5c-0.2,0-0.3,0.2-0.3,0.4C10,7.3,10,7.5,10,7.8L10,7.8z"/>
    </svg>
  );
}

export default EyeShowIcon;
